import FontsizeAdjustHandler from './FontsizeAdjustHandler';
export default{
    created() {
        FontsizeAdjustHandler.$on('setTranslationAlign', this.setTranslationAlign);
    },
    beforeDestroy() {
        FontsizeAdjustHandler.$off('setTranslationAlign', this.setTranslationAlign);
    },
};
